export default class ToggleGif {
  constructor(element) {
    this.element = element;

    this.init();
  }

  init() {
    this.staticSrc = this.element.dataset.toggleimg;
    this.gifSrc = this.element.dataset.togglegif;
    this.altText = this.element.dataset.togglealt;

    this.img = document.createElement('img');
    this.img.className = 'border-radius tooglegif-video-gif';
    this.img.src = this.gifSrc;
    this.img.alt = this.altText;
    this.img.style.cursor = 'pointer';

    this.element.appendChild(this.img);
    this.isStatic = false;

    this.element.addEventListener('click', this.toggleVideo.bind(this));
  }

  toggleVideo() {
    if (this.isStatic) {
      this.img.classList.remove('tooglegif-video-static');
      this.img.classList.add('tooglegif-video-gif');
      this.img.src = this.gifSrc;
      this.isStatic = false;
    } else {
      this.img.classList.remove('tooglegif-video-gif');
      this.img.classList.add('tooglegif-video-static');
      this.img.src = this.staticSrc || this.gifSrc;
      this.isStatic = true;
    }
  }
}
